import React, { PureComponent } from 'react';

class ButtonExpandir extends PureComponent {
    constructor(props) {
        super(props);
        this.onClickExpandirRow = this.onClickExpandirRow.bind(this);
    }

    onClickExpandirRow(event) {
        this.props.expandirRow(this.props.id);
    }

    render() {
        const { claseFlecha } = this.props;
        return (<a className={claseFlecha} aria-hidden="true" onClick={this.onClickExpandirRow}></a>);
    }
}

export default ButtonExpandir;